import { useQuery } from "graphql-hooks";
import { useEffect, useState } from 'react';
import { clientConfig } from "../utilities/configService";

const CMS_QUERY = `query dataQuery {
  websiteConfiguration {
    fieldWebsiteTitle
  }
}`;

export const usePageTitle = () => {
    const [documentTitle, setDocumentTitle] = useState('PowerGuide Fleets');
    const { loading, error, data } = useQuery(CMS_QUERY, {
        variables: {
            limit: 10
        }
    });

    useEffect(() => {
        if (!loading) {
            if (!error) {
                document.title = data.websiteConfiguration.fieldWebsiteTitle;
            }
            else {
                document.title = clientConfig?.DEFAULT_TITLE || '';
            }
        }
    }, [error, loading, data]);

    return [documentTitle, setDocumentTitle];
}
